import { IAppState } from 'src/store/types';

export const getTypesPlacementState = (state: IAppState) => state.requests.typeOfProperty;
export const getSelectedPlacement = (state: IAppState) => state.requests.typeOfProperty.selectedType;
